import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ResetPassword } from '@app/_models/resetPassword';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { headervalue } from 'src/headervalue/header';

const httpOptions = {
  // headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({
  providedIn: 'root'
})

export class ResetPasswordService {

  constructor(private http: HttpClient) { }

  getResetPasswordEmail(emailval) {

    console.log(emailval);
    var temp = this.http.get<any>(`${environment.apiUrl}/auth/checkFlagOnClickOfLink/` + emailval);

    return temp;
  }

  updateResetPassword(ResetPasswordParam: ResetPassword): Observable<ResetPassword> {
    return this.http.post<ResetPassword>(`${environment.apiUrl}/auth/UpdatePassword`, ResetPasswordParam, httpOptions).pipe(

    );
  }

}
